import { PaymentMethodCode } from '@src/domains/payments';
import type { Transaction } from '@src/domains/transactions/types/transaction';

export const isPendingPix = (transaction: Transaction | null | undefined): boolean =>
  Boolean(transaction?.pending && transaction.paymentMethod.code === PaymentMethodCode.Pix);
